import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MainAppLayout from './layouts/MainAppLayout';
import { ErrorBoundary } from './components/common';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './views/authentication/LoginPage';
import Dashboard from './views/main_app/Dashboard';
import EmployeesFluentUI from './views/main_app/EmployeesFluentUI';
import EmployeeDetailsFluentUI from './views/main_app/EmployeeDetailsFluentUI';
import DepartmentFluentUI from './views/main_app/DepartmentFluentUI';
import DepartmentDetailsFluentUI from './views/main_app/DepartmentDetailsFluentUI';
import RoleFluentUI from './views/main_app/RoleFluentUI';
import ClientFluentUI from './views/main_app/ClientFluentUI';
import ClientDetailsFluentUI from './views/main_app/ClientDetailsFluentUI';
import ClientCategoryFluentUI from './views/main_app/ClientCategoryFluentUI';
import AdminUsersFluentUI from './views/main_app/AdminUsersFluentUI';
import CreateAdminUserFluentUI from './views/main_app/CreateAdminUserFluentUI';
import SitesFluentUI from './views/main_app/security_operations/SitesFluentUI';
import SiteDetailsFluentUI from './views/main_app/security_operations/SiteDetailsFluentUI';
import ServicesFluentUI from './views/main_app/security_operations/ServicesFluentUI';
import SiteTypesFluentUI from './views/main_app/security_operations/SiteTypesFluentUI';
import ZonesFluentUI from './views/main_app/security_operations/ZonesFluentUI';
import ClientServicesFluentUI from './views/main_app/security_operations/ClientServicesFluentUI';
import AddClientServiceFluentUI from './views/main_app/security_operations/AddClientServiceFluentUI';
import AddEmployeeFluentUI from './views/main_app/AddEmployeeFluentUI';
import AddClientFluentUI from './views/main_app/AddClientFluentUI';
import ActivityFluentUI from './views/main_app/ActivityFluentUI';
import ClockInFluentUI from './views/main_app/ClockInFluentUI';
import ProfileFluentUI from './views/main_app/ProfileFluentUI';
import UserPrivilegesFluentUI from './views/main_app/administrator/UserPrivilegesFluentUI';
import UserPrivilegesManagementFluentUI from './views/main_app/administrator/UserPrivilegesManagementFluentUI';
import RolePrivilegesManagementFluentUI from './views/main_app/administrator/RolePrivilegesManagementFluentUI';
import InitializeMailboxFluentUI from './views/main_app/administrator/InitializeMailboxFluentUI';
import ShiftsFluentUI from './views/main_app/guard_operations/ShiftsFluentUI';
import ShiftDetailFluentUI from './views/main_app/guard_operations/ShiftDetailFluentUI';
import AssignGuardFluentUI from './views/main_app/guard_operations/AssignGuardFluentUI';
import AssignGuardFormFluentUI from './views/main_app/guard_operations/AssignGuardFormFluentUI';
import AssignSupervisorFluentUI from './views/main_app/guard_operations/AssignSupervisorFluentUI';
import SupervisorAssignmentDetails from './views/main_app/guard_operations/SupervisorAssignmentDetails';
import ShiftScheduleFluentUI from './views/main_app/guard_operations/ShiftScheduleFluentUI';
import GuardShiftReassignFluentUI from './views/main_app/guard_operations/GuardShiftReassignFluentUI';
import SupervisorProfileFluentUI from './views/main_app/guard_operations/SupervisorProfileFluentUI';
import GuardLookupFluentUI from './views/main_app/guard_operations/GuardLookupFluentUI';
import CheckpointsFluentUI from './views/main_app/checkpoints/CheckpointsFluentUI';
import AddCheckpointFluentUI from './views/main_app/checkpoints/AddCheckpointFluentUI';
import CheckpointDetailsFluentUI from './views/main_app/checkpoints/CheckpointDetailsFluentUI';
import QRBatchGenerationFluentUI from './views/main_app/checkpoints/QRBatchGenerationFluentUI';
import CheckpointScansFluentUI from './views/main_app/checkpoints/CheckpointScansFluentUI';
import IncidentReportsFluentUI from './views/main_app/incidents/IncidentReportsFluentUI';
import IncidentDetailsFluentUI from './views/main_app/incidents/IncidentDetailsFluentUI';
import CreateIncidentFluentUI from './views/main_app/incidents/CreateIncidentFluentUI';
import QRAssetsFluentUI from './views/main_app/qr_assets/QRAssetsFluentUI';
import AssignQRFluentUI from './views/main_app/qr_assets/AssignQRFluentUI';
import QRAssetDetailsFluentUI from './views/main_app/qr_assets/QRAssetDetailsFluentUI';
import ReassignQRFluentUI from './views/main_app/qr_assets/ReassignQRFluentUI';
import MemoLayout from './views/main_app/memo/MemoLayout';
import InboxFluentUI from './views/main_app/memo/inbox/InboxFluentUI';
import SentFluentUI from './views/main_app/memo/sent/SentFluentUI';
import DraftsFluentUI from './views/main_app/memo/drafts/DraftsFluentUI';
import ArchivedFluentUI from './views/main_app/memo/archived/ArchivedFluentUI';
import TrashFluentUI from './views/main_app/memo/trash/TrashFluentUI';
import MessageViewFluentUI from './views/main_app/memo/message/MessageViewFluentUI';
import ComposeFluentUI from './views/main_app/memo/compose/ComposeFluentUI';
import CompanySetupWizard from './views/main_app/company_setup/CompanySetupWizard';
import CompanySetupView from './views/main_app/company_setup/CompanySetupView';
import CompanySetupEditRequests from './views/main_app/company_setup/CompanySetupEditRequests';
import SiteMonitoringDashboard from './views/main_app/site_monitoring/SiteMonitoringDashboard';
import ReportPlaceholder from './views/main_app/reports/ReportPlaceholder';
import OnboardClientFluentUI from './views/main_app/client_management/OnboardClientFluentUI';
import SubmissionDetailsFluentUI from './views/main_app/client_management/SubmissionDetailsFluentUI';
import ClientOnboardingForm from './views/public/ClientOnboardingForm';
import GenerateClientBillFluentUI from './views/main_app/billing/GenerateClientBillFluentUI';
import CreateInvoiceFluentUI from './views/main_app/billing/CreateInvoiceFluentUI';
import DebtRecoveryFluentUI from './views/main_app/billing/DebtRecoveryFluentUI';
import InvoicePreviewFluentUI from './views/main_app/billing/InvoicePreviewFluentUI';
import InvoicesListFluentUI from './views/main_app/billing/InvoicesListFluentUI';
import PatrolsFluentUI from './views/main_app/patrols/PatrolsFluentUI';
import PatrolDetailFluentUI from './views/main_app/patrols/PatrolDetailFluentUI';
import {
  SiteAttendanceFluentUI,
  SiteAttendanceDetailFluentUI,
} from './views/main_app/site_attendance';

function App() {
  return (
    <ErrorBoundary>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 3000,
          style: {
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            color: '#fff',
            zIndex: 9999999,
          },
        }}
      />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {/* <Route path="/register" element={<RegisterPage />} /> */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboard/:token" element={<ClientOnboardingForm />} />

        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <MainAppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="employees" element={<EmployeesFluentUI />} />
          <Route path="employee-details/:id" element={<EmployeeDetailsFluentUI />} />
          <Route path="add-employee" element={<AddEmployeeFluentUI />} />
          <Route path="admin-users" element={<AdminUsersFluentUI />} />
          <Route path="create-admin-user" element={<CreateAdminUserFluentUI />} />
          <Route path="initialize-mailbox" element={<InitializeMailboxFluentUI />} />

          <Route path="departments" element={<DepartmentFluentUI />} />
          <Route path="department-details/:id" element={<DepartmentDetailsFluentUI />} />
          <Route path="roles" element={<RoleFluentUI />} />
          <Route path="client-category" element={<ClientCategoryFluentUI />} />
          <Route path="clients" element={<ClientFluentUI />} />
          <Route path="client-details/:id" element={<ClientDetailsFluentUI />} />
          <Route path="add-client" element={<AddClientFluentUI />} />
          <Route path="onboard-client" element={<OnboardClientFluentUI />} />
          <Route path="submission-details/:id" element={<SubmissionDetailsFluentUI />} />

          {/* security operations */}
          <Route path="services" element={<ServicesFluentUI />} />
          <Route path="client-services" element={<ClientServicesFluentUI />} />
          <Route path="add-client-service" element={<AddClientServiceFluentUI />} />
          <Route path="site-types" element={<SiteTypesFluentUI />} />
          <Route path="zones" element={<ZonesFluentUI />} />
          <Route path="sites" element={<SitesFluentUI />} />
          <Route path="site-details/:id" element={<SiteDetailsFluentUI />} />

          {/* guard operations */}

          <Route path="shifts" element={<ShiftsFluentUI />} />
          <Route path="guard-operations/shifts" element={<ShiftsFluentUI />} />
          <Route path="guard-operations/shifts/:shiftId" element={<ShiftDetailFluentUI />} />
          <Route path="guard-operations/assign-guard" element={<AssignGuardFluentUI />} />
          <Route path="guard-operations/assign-guard-form" element={<AssignGuardFormFluentUI />} />
          <Route path="guard-operations/assign-supervisor" element={<AssignSupervisorFluentUI />} />
          <Route
            path="guard-operations/supervisor-assignment/:id"
            element={<SupervisorAssignmentDetails />}
          />
          <Route path="guard-operations/shift-schedule" element={<ShiftScheduleFluentUI />} />
          <Route
            path="guard-operations/guard-shift-reassign"
            element={<GuardShiftReassignFluentUI />}
          />
          <Route
            path="guard-operations/supervisor-profile"
            element={<SupervisorProfileFluentUI />}
          />
          <Route path="guard-operations/guard-lookup" element={<GuardLookupFluentUI />} />

          {/* checkpoints and QR codes */}
          <Route path="checkpoints" element={<CheckpointsFluentUI />} />
          <Route path="checkpoint-details/:id" element={<CheckpointDetailsFluentUI />} />
          <Route path="add-checkpoint" element={<AddCheckpointFluentUI />} />
          <Route path="qr-batch-generation" element={<QRBatchGenerationFluentUI />} />
          <Route path="checkpoint-scans" element={<CheckpointScansFluentUI />} />

          {/* QR Asset Management */}
          <Route path="qr-assets" element={<QRAssetsFluentUI />} />
          <Route path="qr-asset-details/:id" element={<QRAssetDetailsFluentUI />} />
          <Route path="assign-qr/:id" element={<AssignQRFluentUI />} />
          <Route path="reassign-qr/:id" element={<ReassignQRFluentUI />} />

          {/* incidents */}
          <Route path="incident-reports" element={<IncidentReportsFluentUI />} />
          <Route path="incident-details/:id" element={<IncidentDetailsFluentUI />} />
          <Route path="create-incident" element={<CreateIncidentFluentUI />} />

          {/* Internal Memo System */}
          <Route path="memo" element={<MemoLayout />}>
            <Route index element={<InboxFluentUI />} />
            <Route path="inbox" element={<InboxFluentUI />} />
            <Route path="sent" element={<SentFluentUI />} />
            <Route path="drafts" element={<DraftsFluentUI />} />
            <Route path="archived" element={<ArchivedFluentUI />} />
            <Route path="trash" element={<TrashFluentUI />} />
            <Route path="message/:id" element={<MessageViewFluentUI />} />
            <Route path="compose" element={<ComposeFluentUI />} />
          </Route>

          {/* Company Setup */}
          <Route path="company-setup" element={<CompanySetupView />} />
          <Route path="company-setup/wizard" element={<CompanySetupWizard />} />
          <Route path="company-setup/edit-requests" element={<CompanySetupEditRequests />} />

          {/* Billing */}
          <Route path="billing/generate-bill" element={<GenerateClientBillFluentUI />} />
          <Route path="billing/invoices" element={<InvoicesListFluentUI />} />
          <Route path="billing/create-invoice" element={<CreateInvoiceFluentUI />} />
          <Route path="billing/debt-recovery" element={<DebtRecoveryFluentUI />} />
          <Route path="billing/invoice-preview/:id" element={<InvoicePreviewFluentUI />} />

          {/* Site Monitoring */}
          <Route path="site-monitoring" element={<SiteMonitoringDashboard />} />

          {/* Patrols */}
          <Route path="security-operations/patrols" element={<PatrolsFluentUI />} />
          <Route path="security-operations/patrols/:id" element={<PatrolDetailFluentUI />} />

          {/* Site Attendance */}
          <Route path="security-operations/site-attendance" element={<SiteAttendanceFluentUI />} />
          <Route
            path="security-operations/site-attendance/:id"
            element={<SiteAttendanceDetailFluentUI />}
          />

          {/* Security Reporting */}
          <Route
            path="reports/report-1"
            element={<ReportPlaceholder reportNumber="1" reportName="Report 1" />}
          />
          <Route
            path="reports/report-2"
            element={<ReportPlaceholder reportNumber="2" reportName="Report 2" />}
          />
          <Route
            path="reports/report-3"
            element={<ReportPlaceholder reportNumber="3" reportName="Report 3" />}
          />
          <Route
            path="reports/report-4"
            element={<ReportPlaceholder reportNumber="4" reportName="Report 4" />}
          />

          <Route path="login-activity" element={<ActivityFluentUI />} />
          <Route path="clocking-activity" element={<ClockInFluentUI />} />
          <Route path="profile" element={<ProfileFluentUI />} />
          <Route path="user-privileges" element={<UserPrivilegesFluentUI />} />
          <Route path="user-privileges-management" element={<UserPrivilegesManagementFluentUI />} />
          <Route path="role-privileges-management" element={<RolePrivilegesManagementFluentUI />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
